import React from 'react';

export default class GcInputPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'password',
            value: ''
        };
        this.handleChange = this.handleChange.bind(this);
    }

    render() {
        let data_attributes = {
            'data-parsley-password_valid': true,
            'data-parsley-errors-container': '#password_input_errors'
        };
        if (this.props.required) {
            data_attributes['data-parsley-validate-if-empty'] = true;
        }
        return (
            <div className='input-group'>
                {this.props.refresh && 
                    <div className="input-group-prepend input-group-refresh">
                        <span className="input-group-text">
                            <i className="fas fa-sync-alt btn-refresh-password cursor-pointer" onClick={() => this.refreshPassword()}></i>
                        </span>
                    </div>
                }
                <input 
                    type={this.state.type} 
                    name={this.props.name} 
                    id={this.props.id} 
                    autoComplete="new-password" 
                    className="form-control" value={this.state.value} 
                    onChange={this.handleChange} 
                    required={this.props.required} 
                    placeholder={this.props.placeholder} 
                    {...data_attributes}
                />
                {this.props.show && 
                    <div className="input-group-append input-group-show">
                        <span className="input-group-text">
                            <i className="fas fa-eye btn-show-password cursor-pointer" onClick={() => this.toggleType()}></i>
                        </span>
                    </div>
                }
                <div id="password_input_errors" className="w-100"></div>
            </div>
        );
    }

    toggleType() {
        this.setState({
            type: this.state.type == 'text' ? 'password': 'text'
        });
    }

    refreshPassword() {
        let _this = this;
        let url = ENV.base_lang_url + 'auth/create_password';
        fetch(url, { method: 'GET' })
            .then(rtn => rtn.json())
            .then(result => {
                if(result.success) {
                    _this.setState({
                        value: result.password
                    });
                }
            })
            .catch(errorMsg => { console.log(errorMsg); });
    }

    handleChange(event) {    
        this.setState({value: event.target.value});
    }
}